import React from 'react'
import { useParams } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { DepositLimits } from './Components/DepositLimits/DepositLimits'
import { appHistory } from '@core/Utils/routing/history'

export const DepositLimitsEditPage = () => {
  const { depositLimitId } = useParams<{ depositLimitId: string }>()

  const accountHolderNumberPattern = /\d+$/
  const accountHolderNumber = accountHolderNumberPattern.test(depositLimitId || '')
    ? Number(depositLimitId)
    : undefined

  if (!accountHolderNumber) {
    appHistory.push(AppRoutes.Home)
  }

  return <DepositLimits selectedAccountHolderNumber={accountHolderNumber} mode='edit' />
}
